import { render } from "./SurveyQuestionsField.vue?vue&type=template&id=85c79d66&scoped=true"
import script from "./SurveyQuestionsField.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsField.vue?vue&type=script&lang=js"

import "./SurveyQuestionsField.vue?vue&type=style&index=0&id=85c79d66&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c79d66"],['__file',"SurveyQuestionsField.vue"]])

export default __exports__